module.exports = __webpack_public_path__ + "static/media/Picture2.0928e4a7.png";